import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AppStore } from './app.store';

@Injectable({ providedIn: 'root' })
export class AppInitializedGuard implements CanActivate {
  constructor(private readonly appStore: AppStore) {}

  canActivate(): Observable<boolean> {
    this.appStore.clearLoading();

    return of(true);
  }
}
